module.exports = __webpack_public_path__ + "img/35.27820371.jpg";